<template>
  <v-container grid-list-lg class="pa-0">
    <v-slide-y-transition group tag="div" class="layout row wrap">
      <v-flex xs12 md6 v-for="(record, recordId) in records" :key="recordId">
        <RecordContent :record="record" />
      </v-flex>
    </v-slide-y-transition>
  </v-container>
</template>

<script>
import RecordContent from "./RecordContent";
export default {
  props: ["records"],
  components: { RecordContent },
  methods: {
    async remove(record) {
      await record.remove();
      this.$emit("remove");
    }
  }
};
</script>
